export default __webpack_public_path__ + "static/media/inv-claim.9ed2e937.svg";